import React, { useEffect, useState } from 'react';
import styles from './DraftRegistrationModal.module.scss';
import { AddIcon } from 'tt-ui-lib/icons';
import { Button, Modal, CheckBox, Input, DatePicker, Form, PartialLoader } from 'tt-ui-lib/core';
import DragDropField from '../../../core/views/JoinPage/SignUpPage/DragDropField';
import LocationModal from '../../../core/views/JoinPage/SignUpPage/Modals/LocationModal';
import CustomDeleteIconChips from '../../deleteIconChips';

import moment from 'moment';
import { useSelectedContext } from 'context/contextSelector';
import { useMutation, useQuery, useLazyQuery } from '@apollo/client';
import {
  GET_COUNTRIES,
  SAVE_USER_EXPERIENCE,
  UPDATE_USER_AVATAR,
  UPDATE_USER_PROFILE,
  GET_USER,
} from '../../../api';

const LocationPickerInput = ({ onClick, value }) => (
  <Input placeholder="Location*" readOnly value={value?.address || ''} onClick={onClick} />
);

const DraftRegistrationModal = () => {
  const { changeUserData, user } = useSelectedContext((context) => context.user);
  const [form] = Form.useForm();

  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentUser, setCurrentUser] = useState();

  const [avatar, setAvatar] = useState([]);
  const [avatarName, setAvatarName] = useState([]);

  const [isLocationModalOpen, setIsLocationModalOpen] = useState(false);
  const [coordinates, setCoordinates] = useState(null);
  const [address, setAddress] = useState(null);
  const [locationData, setLocationData] = useState(null);
  const [countriesList, setCountriesList] = useState([]);
  const { data: countriesData } = useQuery(GET_COUNTRIES);

  const [tagValue, setTagValue] = useState('');
  const [tagError, setTagError] = useState('');
  const [tags, setTags] = useState([]);

  const isPresent = Form.useWatch(['user_experiences', 'is_present'], form);
  const startDate = Form.useWatch(['user_experiences', 'start_date'], form);

  const [saveUserExperience] = useMutation(SAVE_USER_EXPERIENCE, {
    onError: () => {},
  });
  const [updateUserProfile] = useMutation(UPDATE_USER_PROFILE, {
    onError: () => {},
  });
  const [updateUserAvatar] = useMutation(UPDATE_USER_AVATAR, {
    onError: () => {},
  });

  const [getUser] = useLazyQuery(GET_USER, { variables: { id: user?.id } });
  const getUserValue = async () => {
    if (user && user?.id) {
      const userValue = await getUser();
      if (userValue.data?.user) {
        setCurrentUser(userValue.data.user);
      }
    }
  };

  useEffect(() => {
    getUserValue();
    if (
      user.id &&
      user.is_draft &&
      currentUser?.expertises.length === 0 &&
      user.role_name === 'expert'
    ) {
      setIsOpen(true);
    }
  }, [user, currentUser]);

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleModalClose = (setModalOpen) => setModalOpen(false);

  useEffect(() => {
    if (countriesData) {
      setCountriesList(countriesData.showCountries);
    }
  }, [countriesData]);

  useEffect(() => {
    if (address && locationData && countriesList.length) {
      let country = '';
      if (locationData.country_code) {
        const countryItem = countriesList.find(
          (item) =>
            item.iso_3166_2 === locationData.country_code ||
            item.iso_3166_3 === locationData.country_code
        );
        country = countryItem?.name || '';
      }
      form.setFields([
        {
          name: 'location',
          value: {
            address: address,
            data: {
              latLng: {
                lat: coordinates?.lat.toString(),
                lng: coordinates?.lng.toString(),
              },
              country: country,
              postcode: locationData.postcode || '',
              locality: locationData.locality || '',
              country_code: locationData.country_code || '',
            },
          },
        },
      ]);
    }
  }, [address, locationData, countriesList]);

  const addTag = () => {
    if (tags.length < 10) {
      if (tagValue && tagValue.length < 255) {
        if (!tags.includes(tagValue)) {
          setTags([...tags, tagValue]);
          setTagValue('');
          setTagError('');
        } else {
          setTagError('Тag already exists.');
        }
      } else if (tagValue.length > 255) {
        setTagError(
          `This field cannot be longer than 255 characters. Length ${tagValue.length} characters.`
        );
      }
    } else {
      setTagError(`Can not add more than 10 expertise`);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addTag();
    }
  };

  const onChangeTags = (value) => {
    setTagError('');
    setTagValue(value);
  };

  const onHandleDeleteTag = (index) => {
    const filteredTags = tags.filter((tag, i) => i !== index);
    setTags(filteredTags);
  };

  const onSubmit = async (data) => {
    console.log('adresa:', address);
    console.log('data:', data);
    console.log('avatarName:', avatarName);

    const startDateSelected = data?.user_experiences?.start_date;
    const endDate = data?.user_experiences?.end_date;
    const userExperiences = { ...data?.user_experiences };

    setLoading(true);
    userExperiences.start_date = moment(startDateSelected).format('YYYY-MM-DD');
    if (endDate) {
      userExperiences.end_date = moment(endDate).format('YYYY-MM-DD');
    }
    const userProfileData = {
      location: {
        address: data?.location?.address,
        data: { ...data?.location?.data },
      },
      last_name: data?.last_name || undefined,
    };

    if (user.roles?.find((elem) => elem.name === 'expert')) {
      userProfileData.expertises = tags.map((item) => ({ name: item }));
    }

    const userProfile = await updateUserProfile({
      variables: {
        input: userProfileData,
      },
    });
    const userExperience = await saveUserExperience({
      variables: { input: [userExperiences] },
    });

    let userAvatar;
    if (avatarName && avatarName[0]?.newName) {
      userAvatar = await updateUserAvatar({
        variables: { input: { avatar: avatarName[0].newName } },
      });
      if (userAvatar.data && userAvatar.data.updateUserAvatar) {
        changeUserData({
          ...user,
          avatar: userAvatar.data.updateUserAvatar.avatar,
        });
      }
    }

    if (
      userExperience &&
      userExperience.data &&
      !userExperience.errors &&
      userProfile &&
      userProfile.data &&
      !userProfile.errors &&
      (user.avatar || (userAvatar && userAvatar.data && !userAvatar.errors))
    ) {
      form.resetFields();
      setTags([]);
      setIsOpen(false);
    }
    setLoading(false);
  };

  return (
    <Modal open={isOpen} onClose={handleClose} className={styles.modal}>
      <div className={styles.container}>
        <div className={styles.modalItemBlock}>
          <div className={styles.title}>
            Please add the missing details to this form. Thanks a bunch!
          </div>
          <div className={styles.subTitle}>These fields are mandatory. Please complete them.</div>
        </div>
        <Form form={form} onFinish={onSubmit} className={styles.formContainer}>
          {user && !user.avatar && (
            <div className={styles.uploadAvatar}>
              <DragDropField
                title="Add your photo"
                fieldName="photo"
                dragDropDesc="Select and drop your file here"
                add="You can add jpg. or png. file with the maximum size 2 MB."
                maxFiles={1}
                isMultiple={false}
                isImage
                files={avatar}
                setFiles={setAvatar}
                path="avatars"
                filesNames={avatarName}
                setFilesNames={setAvatarName}
                forModal
              />
            </div>
          )}
          {user && !user.last_name && (
            <Form.Item
              name="last_name"
              rules={[
                {
                  required: true,
                  message: 'Please fill out the rest fields. This is mandatory.',
                },
              ]}
            >
              <Input label="Last Name*" />
            </Form.Item>
          )}
          <div className={styles.inputsGroups}>
            <Form.Item
              name="location"
              rules={[{ required: true, message: 'Please select your location.' }]}
            >
              <LocationPickerInput onClick={() => setIsLocationModalOpen(true)} />
            </Form.Item>
            {user && !!user.roles?.find((elem) => elem.name === 'expert') && (
              <>
                <div className={styles.tagRow}>
                  <Input
                    label="Expertise*"
                    className={styles.tagInput}
                    value={tagValue}
                    onChange={(e) => onChangeTags(e.target.value)}
                    onKeyDown={handleKeyPress}
                  />
                  <AddIcon className={styles.tagAddIcon} onClick={() => addTag()} />
                </div>
                {tagError && (
                  <div style={{ color: '#d32f2f', margin: '3px 14px 0' }}>{tagError}</div>
                )}
                <CustomDeleteIconChips tags={tags} handleDeleteTag={onHandleDeleteTag} />
              </>
            )}
          </div>
          <div className={styles.experience}>
            <div>Experience*</div>
            <div className={styles.inputsGroups}>
              <div className={styles.inputItems}>
                <Form.Item
                  style={{ width: '100%' }}
                  name={['user_experiences', 'title']}
                  rules={[
                    {
                      required: true,
                      message: 'Please fill out the rest fields. This is mandatory.',
                    },
                  ]}
                >
                  <Input style={{ width: '100%' }} size="middle" label="Title*" />
                </Form.Item>

                <Form.Item
                  style={{ width: '100%' }}
                  name={['user_experiences', 'company_name']}
                  rules={[
                    {
                      required: true,
                      message: 'Please fill out the rest fields. This is mandatory.',
                    },
                  ]}
                >
                  <Input style={{ width: '100%' }} size="middle" label="Company*" />
                </Form.Item>
              </div>
              <div className={styles.inputItems}>
                <Form.Item
                  className={styles.datePicker}
                  name={['user_experiences', 'start_date']}
                  rules={[
                    {
                      required: true,
                      message: 'Please fill out the rest fields. This is mandatory.',
                    },
                  ]}
                >
                  <DatePicker
                    label="Start Date*"
                    style={{ width: '100%' }}
                    picker="month"
                    size="middle"
                    inputReadOnly
                  />
                </Form.Item>

                <Form.Item
                  className={styles.datePicker}
                  name={['user_experiences', 'end_date']}
                  rules={[
                    {
                      required: !isPresent,
                      message: 'Please fill out the rest fields. This is mandatory.',
                    },
                  ]}
                >
                  <DatePicker
                    label="End Date*"
                    style={{ width: '100%' }}
                    picker="month"
                    size="middle"
                    inputReadOnly
                    disabled={isPresent || !startDate}
                    disabledDate={(current) => {
                      if (!startDate) return false;
                      return current && current.isBefore(startDate, 'month');
                    }}
                  />
                </Form.Item>
              </div>
            </div>

            <Form.Item
              name={['user_experiences', 'is_present']}
              rules={[
                {
                  required: false,
                  message: 'Please fill out the rest fields. This is mandatory.',
                },
              ]}
            >
              <CheckBox
                label="Present"
                onChange={(e) => {
                  const { checked } = e.target;
                  form.setFieldsValue({
                    user_experiences: {
                      ...form.getFieldValue('user_experiences'),
                      end_date: checked
                        ? null
                        : form.getFieldValue(['user_experiences', 'end_date']),
                      is_present: checked,
                    },
                  });
                }}
              />
            </Form.Item>
          </div>
          <div>*This is public information.</div>
          <div className={styles.buttonGroup}>
            <Button
              type="primary"
              disabled={!tags.length || tags.length === 0}
              onClick={() => form.submit()}
            >
              Proceed
            </Button>
          </div>
        </Form>
      </div>
      <LocationModal
        handleClose={handleModalClose}
        setIsOpen={setIsLocationModalOpen}
        isModelOpen={isLocationModalOpen}
        setCoordinates={setCoordinates}
        coordinates={coordinates}
        setAddress={setAddress}
        address={address}
        setLocationData={setLocationData}
      />
      {loading && <PartialLoader loading={loading} />}
    </Modal>
  );
};

export default DraftRegistrationModal;
